import React from 'react';
import { Box } from '@mui/material';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

interface PublicPageLayoutProps {
  children: React.ReactNode;
}

const PublicPageLayout: React.FC<PublicPageLayoutProps> = ({ children }) => {
  return (
    <>
      {/* Background gradient layer - fixed and behind everything */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          // Clean diagonal gradient from dark teal (top-left) to almost black (bottom-right)
          background: 'linear-gradient(135deg, #005173 0%, #00334E 25%, #001f2e 50%, #0a0f14 75%, #000000 100%)',
        }}
      />
      
      {/* Content layer - above background, below header */}
      <Box
        sx={{
          minHeight: '100vh',
          width: '100%',
          color: 'white',
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {/* Header - sits at highest z-index */}
        <PublicHeader />
        
        {/* Main content with padding for fixed header */}
        <Box component="main" sx={{ flexGrow: 1, position: 'relative', pt: '80px' }}>
          {children}
        </Box>
        
        {/* Footer */}
        <PublicFooter />
      </Box>
    </>
  );
};

export default PublicPageLayout; 